/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ReportAggregationModeRepresentation as ReportAggregationModeRepresentationModel } from '@veeam-vspc/models/web-controllers';

export type ReportAggregationModeRepresentation = ReportAggregationModeRepresentationModel;
export const ReportAggregationModeRepresentation = ReportAggregationModeRepresentationModel;
